module.exports = __webpack_public_path__ + "img/login.3097721c.png";